import PropTypes from 'prop-types'
import './style.css'

const Evidence = props => (
    <>
        { 
            props.summary.split( '\n' ).map(
                ( text, index ) => (
                    <tspan 
                        className="coe__node__evidence__summary"
                        key={ 'break-' + index }
                        x="0" 
                        dy="1.5rem">
                        { text }
                    </tspan>
                )
            )
        }
        <a href={ props.url } target="_blank" rel="noreferrer">
            <tspan className="coe__node__evidence__link" x="0" dy="1.5rem">
                { props.url }
            </tspan>
        </a>
        <tspan x="0" dy=".75rem">&nbsp;</tspan>
    </> 
)

Evidence.propTypes = {
    summary: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}

export default Evidence